
import { Swiper } from 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.esm.browser.min.js';
class ConfiguratorSwiper extends HTMLElement {
  constructor() {
    super();
    this.container = document.createElement("div");
  }

  static get observedAttributes() {
    return ["collection-handle","modal-type"];
  }

  get collectionHandle() {
    return this.getAttribute("collection-handle");
  }
  get modalType() {
    return this.getAttribute("modal-type");
  }

  connectedCallback() {
    console.log(this.isConnected);
    this._render();
    this.addCloseButtonToSlides()
    this._attachEventHandlers();
  }

  addCloseButtonToSlides() {

    const slides =  document.body.querySelectorAll(".swiper-slide");
    slides.forEach((slide) => {
      const cancelButton = document.createElement("div");
      cancelButton.innerHTML = `<svg class="cancel" xmlns="http://www.w3.org/2000/svg" width="16.296" height="16.576" viewBox="0 0 16.296 16.576">
      <line class="cancel" id="Line_168" data-name="Line 168" x2="13.467" y2="13.748" transform="translate(1.414 1.414)" fill="none" stroke="#575340" stroke-linecap="round" stroke-width="2"/>
      <line class="cancel" id="Line_164" data-name="Line 164" x1="13.467" y2="13.748" transform="translate(1.414 1.414)" fill="none" stroke="#575340" stroke-linecap="round" stroke-width="2"/>
    </svg>`
      cancelButton.classList.add("cancel");
      cancelButton.addEventListener("click", (e) => {
        const modal = document.querySelector("x-modal");
        modal.closeCollectionModal();
      })
      slide.appendChild(cancelButton)
    })
  }

  _render() {
    const slideShow = document.getElementById(
      `${this.collectionHandle}-enhance-modal-${this.modalType}`
    );
    const slideShowTemplate = slideShow
      .querySelector("template")
      .content.cloneNode(true);

    this.container.appendChild(slideShowTemplate);
    this.appendChild(this.container);

    if (this.modalType === "buy") {
    const swiper = new Swiper(this.querySelector(".swiper"), {
      slidesPerView: 1,
      centeredSlides: true,
      centeredSlidesBounds: true,
      loop: false,
      spaceBetween: 0,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      paginationClickable: false,
      scrollbar: {
        enabled: false,
      },
      pagination: {
        el: this.querySelector(".swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1.32,
        },
        // when window width is >= 480px
        501: {
          slidesPerView: 1.2,
          spaceBetween: 2,
        },
        // when window width is >= 640px
        640: {
          slidesPerView: 1.32,
        }
      }
    });
  }
  else {
  const swiper = new Swiper(this.querySelector(".swiper"), {
    slidesPerView: 1.32,
    centeredSlides: true,
    centeredSlidesBounds: true,
    loop: true,
    spaceBetween: 20,
    slidesPerGroup: 1,
    watchSlidesProgress: true,
    paginationClickable: true,
    scrollbar: {
      enabled: false,
    },
    pagination: {
      el: this.querySelector(".swiper-pagination"),
      clickable: true,
    },
    navigation: {
      nextEl: this.querySelector(".swiper-button-next"),
      prevEl: this.querySelector(".swiper-button-prev"),
    },
    breakpoints: {
      // when window width is >= 320px
      320: {
        slidesPerView: 1.15,
        spaceBetween: 0.25,
      },
      // when window width is >= 480px
      501: {
        slidesPerView: 1.2,
        spaceBetween: 1.25,
      },
      // when window width is >= 640px
      640: {
        slidesPerView: 1.32,
      }
    }
  });
}
}

  _attachEventHandlers() { }
}
window.customElements.define("x-swiper", ConfiguratorSwiper);
